export default "__VITE_PUBLIC_ASSET__7cda06d3__"